import { createAnalyticsChannel } from '@muse/analytics'

export type TShareParams = {
  requestId?: number
}

export const enum TShareEventName {
  Open = 'open',
}

type TShareEventOpen = {
  event: TShareEventName.Open
  requestId: number
}

export type TShareEvent = TShareEventOpen

export const shareChannel = createAnalyticsChannel<TShareEvent, TShareParams>('share')
